// @ts-check
const header = document.getElementById( 'site-header' );
const burger = document.getElementById( 'mobile-menu-toggle' );
const mobileMenu = document.getElementById( 'mobile-menu' );
const mobileMenuLinks = mobileMenu.querySelectorAll( 'a' );

burger?.addEventListener( 'click', toggle_menu );
mobileMenuLinks.forEach( link => link.addEventListener( 'click', toggle_menu ) );

function toggle_menu() {
    header?.toggleAttribute( 'data-menu-open' );
    toggleAttrValue( 'aria-expanded', burger );
    toggleAttrValue( 'aria-hidden', mobileMenu );
    toggleBodyOverflow();
}

function toggleAttrValue( attribute, element ) {
    element?.setAttribute( attribute, element.getAttribute( attribute ) === 'true' ? 'false' : 'true' );
}

function toggleBodyOverflow() {
    document.body.classList.toggle( 'overflowNone' );
}